import React from 'react'

function PaginationNumbers({ currentPage, totalPages, onPageChange }) {
  if (totalPages <= 1) return null

  const getPages = () => {
    const pages = []
    if (totalPages <= 7) {
      for (let i = 1; i <= totalPages; i++) pages.push(i)
    } else if (currentPage <= 4) {
      pages.push(1, 2, 3, 4, 5, '...', totalPages)
    } else if (currentPage >= totalPages - 3) {
      pages.push(1, '...', totalPages - 4, totalPages - 3, totalPages - 2, totalPages - 1, totalPages)
    } else {
      pages.push(1, '...', currentPage - 1, currentPage, currentPage + 1, '...', totalPages)
    }
    return pages
  }

  const pages = getPages()

  return (
    <nav className='mb-4'>
      <ul style={{ display: 'flex', gap: 8, listStyle: 'none', padding: 0, margin: 0, justifyContent: 'center' }}>
        {currentPage > 1 && (
            <li
            style={{
                color: '#2b9797',
                marginRight: 8,
                cursor: 'pointer',
                fontWeight: 'bold'
            }}
            onClick={() => onPageChange(currentPage - 1)}
            >
            Prev
            </li>
        )}
        {pages.map((page, idx) => (
            page === '...' ? (
                <li key={`dots-${idx}`} style={{ color: '#2b9797', cursor: 'default' }}>...</li>
            ) : (
                <li
                key={`page-${page}-${idx}`}
                style={{
                    color: page === currentPage ? '#2b9797' : '#2b9797',
                    fontWeight: page === currentPage ? 'bold' : 'normal',
                    cursor: 'pointer',
                    textDecoration: page === currentPage ? 'underline' : 'none'
                }}
                onClick={() => page !== currentPage && onPageChange(page)}
                >
                {page}
                </li>
            )
            ))}
        <li
          style={{
            color: currentPage === totalPages ? '#aaa' : '#2b9797',
            marginLeft: 8,
            cursor: currentPage === totalPages ? 'not-allowed' : 'pointer',
            fontWeight: 'bold'
          }}
          onClick={() => currentPage < totalPages && onPageChange(currentPage + 1)}
        >
          Next
        </li>
      </ul>
    </nav>
  )
}

export default PaginationNumbers
